/**
 * @generated SignedSource<<07cbcf739262ce1a890d2043ed70ff26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TranscriptPanel_DismissLowLanguageConfidenceRegenerationBannerMutation$variables = {
  meetingRecordingId: string;
};
export type TranscriptPanel_DismissLowLanguageConfidenceRegenerationBannerMutation$data = {
  readonly dismissLanguageRegenerationBanner: {
    readonly meetingRecording: {
      readonly showLowLanguageConfidenceRegenerationBanner: boolean | null;
    };
  } | null;
};
export type TranscriptPanel_DismissLowLanguageConfidenceRegenerationBannerMutation = {
  response: TranscriptPanel_DismissLowLanguageConfidenceRegenerationBannerMutation$data;
  variables: TranscriptPanel_DismissLowLanguageConfidenceRegenerationBannerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "meetingRecordingId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "meetingRecordingId",
    "variableName": "meetingRecordingId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showLowLanguageConfidenceRegenerationBanner",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TranscriptPanel_DismissLowLanguageConfidenceRegenerationBannerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DismissLanguageRegenerationBanner",
        "kind": "LinkedField",
        "name": "dismissLanguageRegenerationBanner",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecording",
            "kind": "LinkedField",
            "name": "meetingRecording",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TranscriptPanel_DismissLowLanguageConfidenceRegenerationBannerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DismissLanguageRegenerationBanner",
        "kind": "LinkedField",
        "name": "dismissLanguageRegenerationBanner",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecording",
            "kind": "LinkedField",
            "name": "meetingRecording",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "174ba27d0d8dbf119f3914265ed822ce",
    "id": null,
    "metadata": {},
    "name": "TranscriptPanel_DismissLowLanguageConfidenceRegenerationBannerMutation",
    "operationKind": "mutation",
    "text": "mutation TranscriptPanel_DismissLowLanguageConfidenceRegenerationBannerMutation(\n  $meetingRecordingId: ID!\n) {\n  dismissLanguageRegenerationBanner(meetingRecordingId: $meetingRecordingId) {\n    meetingRecording {\n      showLowLanguageConfidenceRegenerationBanner\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cc890d623c198f43895de354dd3063bc";

export default node;
